export const heroLead = {
  tag: "今日话题",
  title: "一条热搜牵出三段旧闻，吃瓜群众把时间线捋明白了",
  summary:
    "从凌晨的一条动态开始，围观的人越聚越多。有人翻旧帖，有人做时间线，讨论区里最热的那条总结，被截图转了几百手。",
  meta: ["3 小时前更新", "讨论 1.2 万", "围观 48 万"],
  image:
    "https://readdy.ai/api/search-image?query=abstract%20editorial%20collage%20of%20warm%20terracotta%20and%20amber%20paper%20cut%20shapes%20overlapping%20with%20soft%20shadows%2C%20stylized%20artistic%20composition%20for%20a%20gossip%20news%20portal%20cover%2C%20no%20text%2C%20warm%20neutral%20background&width=1100&height=760&seq=gossip-hero-01&orientation=portrait",
};

export const heroSideStories = [
  {
    id: "hs-1",
    title: "凌晨那条被删的动态，截图已经传疯了",
    summary: "发布不到十分钟就消失，讨论区连夜补档。",
    time: "1 小时前",
  },
  {
    id: "hs-2",
    title: "两个人被拍到同框之后，评论区先吵了起来",
    summary: "同一张图，三种解读，谁也说服不了谁。",
    time: "2 小时前",
  },
  {
    id: "hs-3",
    title: "老搭档突然不再互动，粉丝做的对比表火了",
    summary: "从点赞到取关，时间线被扒得明明白白。",
    time: "5 小时前",
  },
];

export const trendingPosts = [
  {
    id: "tr-1",
    rank: 1,
    title: "热搜换了一轮又一轮，最后留下的还是这桩旧事",
    summary: "越扒越多的细节，让围观的人凑齐了整条时间线。",
    heat: "98.2 万",
    tag: "爆",
  },
  {
    id: "tr-2",
    rank: 2,
    title: "回应来得太快，网友反而更想追问下一句",
    summary: "一份简短声明，评论区却自动分成两拨。",
    heat: "76.5 万",
    tag: "热",
  },
  {
    id: "tr-3",
    rank: 3,
    title: "剧组花絮外流，正片还没播讨论先热了",
    summary: "一段不到一分钟的片段，被逐帧拆开来看。",
    heat: "54.9 万",
    tag: "热",
  },
  {
    id: "tr-4",
    rank: 4,
    title: "同款被扒出来，柜姐的回复成了新的谈资",
    summary: "从衣服到配饰，围观群众的眼睛比镜头还尖。",
    heat: "41.3 万",
    tag: "新",
  },
  {
    id: "tr-5",
    rank: 5,
    title: "直播里的一句话，第二天上了三条热搜",
    summary: "当时没人当真，回放出来全在刷“早就说了”。",
    heat: "33.7 万",
    tag: "新",
  },
];

export const topicZones = [
  {
    id: "zone-1",
    name: "娱乐圈闲聊",
    desc: "戏里戏外，话题从开机聊到杀青。",
    count: "热帖 328",
    color: "primary",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20stage%20spotlight%20with%20warm%20red%20and%20amber%20paper%20cutout%20shapes%2C%20stylized%20artistic%20poster%20texture%2C%20no%20text%2C%20warm%20neutral%20background&width=800&height=600&seq=gossip-zone-01&orientation=landscape",
  },
  {
    id: "zone-2",
    name: "综艺现场",
    desc: "剪辑之外的画面，才最有嚼头。",
    count: "热帖 214",
    color: "accent",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20television%20screen%20shapes%20with%20amber%20and%20cream%20geometric%20cutouts%2C%20stylized%20artistic%20poster%20texture%2C%20no%20text%2C%20warm%20neutral%20background&width=800&height=600&seq=gossip-zone-02&orientation=landscape",
  },
  {
    id: "zone-3",
    name: "路人视角",
    desc: "偶遇、同框、街拍，围观第一现场。",
    count: "热帖 176",
    color: "secondary",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20city%20skyline%20silhouette%20made%20of%20soft%20mauve%20and%20cream%20paper%20layers%2C%20stylized%20artistic%20poster%20texture%2C%20no%20text%2C%20warm%20neutral%20background&width=800&height=600&seq=gossip-zone-03&orientation=landscape",
  },
  {
    id: "zone-4",
    name: "旧事重提",
    desc: "翻出来的老料，配新瓜一起下饭。",
    count: "热帖 132",
    color: "primary",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20stack%20of%20old%20newspaper%20shapes%20in%20terracotta%20and%20beige%20paper%20cutout%20style%2C%20stylized%20artistic%20poster%20texture%2C%20no%20text%2C%20warm%20neutral%20background&width=800&height=600&seq=gossip-zone-04&orientation=landscape",
  },
];

export const discussionThreads = [
  {
    id: "th-1",
    title: "把这次事件的完整时间线整理出来了，欢迎补充",
    summary: "按小时排的，从最早那条动态一直到最后一次回应，中间漏掉的楼下补。",
    author: "吃瓜不站队",
    replies: 482,
    views: "12.6 万",
    lastActive: "3 分钟前",
    pinned: true,
  },
  {
    id: "th-2",
    title: "同一个动作，怎么就有两种完全相反的解读？",
    summary: "理性讨论，别上升，只想把逻辑盘清楚。",
    author: "旁观者甲",
    replies: 316,
    views: "8.9 万",
    lastActive: "11 分钟前",
    pinned: false,
  },
  {
    id: "th-3",
    title: "今晚的直播有人看了吗，那段话到底几个意思",
    summary: "回放链接放楼里了，从 12 分开始看。",
    author: "熬夜党",
    replies: 274,
    views: "7.2 万",
    lastActive: "26 分钟前",
    pinned: false,
  },
  {
    id: "th-4",
    title: "整理了一版同款清单，价格标得明明白白",
    summary: "纯分享，不恰饭，买到同款的记得回来报到。",
    author: "细节控",
    replies: 158,
    views: "5.4 万",
    lastActive: "42 分钟前",
    pinned: false,
  },
  {
    id: "th-5",
    title: "这波热度过去之后，下一个话题会是谁",
    summary: "开个楼随便聊聊，茶余饭后随便说。",
    author: "闲聊王",
    replies: 93,
    views: "3.1 万",
    lastActive: "1 小时前",
    pinned: false,
  },
];

export const hotComments = [
  {
    id: "cm-1",
    content: "本来只是路过看一眼，结果把整栋楼都刷完了，这瓜是真管饱。",
    author: "楼下吃瓜群众",
    likes: 3260,
    reply: "这条说到我心里了",
  },
  {
    id: "cm-2",
    content: "别急着下结论，等下一波回应出来再聊，现在说啥都太早。",
    author: "冷静围观",
    likes: 2140,
    reply: "蹲一个后续",
  },
  {
    id: "cm-3",
    content: "每一次都能在评论区学到新角度，这才是最好的谈资。",
    author: "茶余饭后",
    likes: 1875,
    reply: "评论区比正文好看",
  },
];

export const teaTalkList = [
  {
    id: "tt-1",
    title: "三个细节被忽略，回过头看全是伏笔",
    tag: "复盘",
  },
  {
    id: "tt-2",
    title: "一句话让评论区集体沉默，热闹背后的分寸感",
    tag: "观点",
  },
  {
    id: "tt-3",
    title: "围观也要有边界，这届吃瓜群众越来越懂了",
    tag: "闲聊",
  },
];

export const siteStats = [
  { label: "今日热帖", value: "1,286" },
  { label: "在聊话题", value: "342" },
  { label: "新鲜谈资", value: "97" },
  { label: "围观人次", value: "68.4 万" },
];

export const footerColumns = [
  {
    title: "逛一逛",
    links: ["今日热帖", "话题分区", "讨论区", "围观热评"],
  },
  {
    title: "聊一聊",
    links: ["吃瓜闲聊", "茶余饭后", "谈资订阅", "新人报到"],
  },
  {
    title: "关于",
    links: ["站点介绍", "内容规范", "联系合作", "意见反馈"],
  },
];